module.exports = __webpack_public_path__ + "img/163-papua-new-guinea.9beac01f.svg";